import React from 'react';

const AuthForm = ({
  authMode,
  setAuthMode,
  authError,
  email,
  setEmail,
  password,
  setPassword,
  handleSignIn,
  handleSignUp,
  handleSignInWithGoogle,
  continueAsGuest,
}) => {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#4FAEA5',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: '"Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif',
      padding: '20px',
    }}>
      {/* Responsive styles for login */}
      <style>{`
        .login-logo {
          width: 200px;
          height: 200px;
          margin-bottom: 24px;
        }
        .login-card {
          background: rgba(255,255,255,0.95);
          border-radius: 24px;
          padding: 40px;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.2);
          box-sizing: border-box;
        }
        .login-title {
          color: #1a1a2e;
          font-size: 28px;
          text-align: center;
          margin-bottom: 8px;
          margin-top: 0;
        }
        .login-subtitle {
          color: #64748b;
          text-align: center;
          margin-bottom: 32px;
          font-size: 14px;
        }
        .login-input {
          width: 100%;
          padding: 14px 16px;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          background: #f8fafc;
          color: #1a1a2e;
          font-size: 16px;
          margin-bottom: 12px;
          outline: none;
          box-sizing: border-box;
        }
        .login-input:last-of-type {
          margin-bottom: 16px;
        }
        .login-btn {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: none;
          font-size: 16px;
          cursor: pointer;
          box-sizing: border-box;
        }
        @media (max-width: 480px) {
          .login-logo {
            width: 140px;
            height: 140px;
            margin-bottom: 16px;
          }
          .login-card {
            padding: 24px 20px;
            border-radius: 20px;
            max-width: calc(100% - 16px);
          }
          .login-title {
            font-size: 22px;
          }
          .login-subtitle {
            margin-bottom: 24px;
            font-size: 13px;
          }
          .login-input {
            padding: 12px 14px;
            font-size: 15px;
          }
          .login-btn {
            padding: 12px;
            font-size: 15px;
          }
        }
      `}</style>

      {/* Logo */}
      <img
        src={process.env.PUBLIC_URL + '/logo.png'}
        alt="Ripety - Learn Chinese"
        className="login-logo"
      />

      <div className="login-card">
        <h1 className="login-title">Welcome to Ripety</h1>
        <p className="login-subtitle">Learn Chinese, Fast & Fun!</p>

        {authError && (
          <div style={{
            background: authError.includes('Check your email') ? 'rgba(34,197,94,0.2)' : 'rgba(239,68,68,0.2)',
            color: authError.includes('Check your email') ? '#22c55e' : '#ef4444',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '16px',
            fontSize: '14px',
            textAlign: 'center',
          }}>{authError}</div>
        )}

        <form onSubmit={authMode === 'login' ? handleSignIn : handleSignUp}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            style={{ marginBottom: '16px' }}
          />
          <button
            type="submit"
            className="login-btn"
            style={{
              background: '#4FAEA5',
              color: '#fff',
              fontWeight: '600',
              marginBottom: '12px',
            }}
          >
            {authMode === 'login' ? 'Sign In' : 'Sign Up'}
          </button>
        </form>

        <button
          onClick={handleSignInWithGoogle}
          className="login-btn"
          style={{
            border: '1px solid #e2e8f0',
            background: '#fff',
            color: '#1a1a2e',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          Continue with Google
        </button>

        <div style={{ textAlign: 'center', marginBottom: '16px' }}>
          <button
            onClick={() => setAuthMode(authMode === 'login' ? 'signup' : 'login')}
            style={{
              background: 'none',
              border: 'none',
              color: '#4FAEA5',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            {authMode === 'login' ? "Don't have an account? Sign up" : 'Already have an account? Sign in'}
          </button>
        </div>

        <div style={{
          borderTop: '1px solid #e2e8f0',
          paddingTop: '16px',
          textAlign: 'center',
        }}>
          <button
            onClick={continueAsGuest}
            style={{
              background: 'none',
              border: 'none',
              color: '#94a3b8',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Continue as Guest (progress won't be saved)
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
